import { IPaymentState } from "./types";

export const initialState: IPaymentState = {
	errorMessage: null,
	paymentReference: null,
	paymentData: null,
	orderDetail: null,
	orderStatus: "idle",
};
